.button {
  min-width: auto;
  white-space: nowrap;
}
